PegasusTemplate.SocialFollowController = Ember.ObjectController.extend({
  needs: ['toolbar', 'host']
});
